import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-improvement-information',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule, MatSelectModule, MatButtonModule, MatFormFieldModule, MatIconModule],
  templateUrl: './improvement-information.component.html',
  styleUrl: './improvement-information.component.scss'
})
export class ImprovementInformationComponent {
  primaryMeasure!: string;
  secondaryMeasure!: string;
  tertiaryMeasure!: string;
  grossBuildingArea!: number;
  grossLeasableArea!: number;
  netBuildingArea!: number;
  usableBuildingArea!: number;
  netRentableArea!: number;
  landToBuildingRatio!: number;
  yearBuilt!: number;
  yearLastRenovated!: number;
  numberOfBuildings!: number;
  numberOfStories!: number;
  numberOfUnits!: number;
  unitType!: string;
  basicConstruction!: string;
  exteriorWalls!: string;
  roofType!: string;
  coolingSystem!: string;
  fireProtection!: string;
  numberOfPassengerElevators!: number;
  numberOfFreightElevators!: number;
}
